<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'setUserAction',
      'setLoginAction',
      'setUserInfoAction'
    ]),
    setUserData (response) {
      this.setUserAction(response ? response.data.user || response.data.data : null)
      this.setLoginAction(!!response)
      this.setUserInfo(response ? response.headers : null)
    },
    setUserInfo (headers) {
      if (headers && headers.uid) {
        let expiry = headers.expiry * 1000
        let info = {
          uid: headers.uid,
          client: headers.client,
          'access-token': headers['access-token'],
          'content-type': 'application/json'
        }
        this.setUserInfoAction(info)
        this.$ls.set('userInfo', info, expiry)
      } else {
        this.setUserInfoAction(null)
        this.$ls.remove('userInfo')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/loginData.vue